export enum OrderType {
  NOT_SPECIAL = "NOT_SPECIAL",
  NEW_PATIENT = "NEW_PATIENT",
  CONTINUATION_NEW_IMPRESSIONS = "CONTINUATION_NEW_IMPRESSIONS",
  CONTINUATION_EXISTING_IMPRESSIONS = "CONTINUATION_EXISTING_IMPRESSIONS",
  RETAINER = "RETAINER",
  PRE_EVALUATION = "PRE_EVALUATION",
}
